
import { TComment, TLessonProject, TProject, TProjectLike, TToggleLike } from "../../models/project/project";
import { useApiClient } from "../apiClients";
import {
  ENDPOINTS_COMMENTS,
  ENDPOINTS_LESSON_PROJECT,
  ENDPOINTS_LESSON_PROJECT_CONDITION,
  ENDPOINTS_LIKES,
  ENDPOINTS_PROJECT_LIST,
  ENDPOINTS_PROJECTS,
  ENDPOINTS_STORE,
} from "./endpoints";

export const useProjectApi = () => {
  const apiClient = useApiClient();

  // ----------------------------------------------------------------------
  // Projects
  // ----------------------------------------------------------------------
  const getProjects = () =>
    apiClient.get<TProject[]>(ENDPOINTS_PROJECTS.GET_ALL);
  const getProjectById = (id: number) =>
    apiClient.get<TProject>(ENDPOINTS_PROJECTS.GET_BY_ID(id));
  const getProjectsByUserAppId = () =>
    apiClient.get<TProject[]>(ENDPOINTS_PROJECTS.GET_BY_USERAPP_ID());
  const createProject = (data: TProject) =>
    apiClient.post<TProject>(ENDPOINTS_PROJECTS.POST, data);
  const updateProject = (id: number, data: TProject) =>
    apiClient.put<TProject>(ENDPOINTS_PROJECTS.PUT(id), data);
  const deleteProject = (id: number) =>
    apiClient.delete(ENDPOINTS_PROJECTS.DELETE(id));

  // ----------------------------------------------------------------------
  // LessonProject
  // ----------------------------------------------------------------------
  const getAllLessonProjects = () =>
    apiClient.get<TLessonProject[]>(ENDPOINTS_LESSON_PROJECT.GET_ALL);

  const getLessonProjectById = (id: number) =>
    apiClient.get<TLessonProject>(ENDPOINTS_LESSON_PROJECT.GET_BY_ID(id));

  const createLessonProject = (data: TLessonProject) =>
    apiClient.post<TLessonProject>(ENDPOINTS_LESSON_PROJECT.POST, data);

  const updateLessonProject = (id: number, data: TLessonProject) =>
    apiClient.put<TLessonProject>(ENDPOINTS_LESSON_PROJECT.PUT(id), data);

  const deleteLessonProject = (id: number) =>
    apiClient.delete(ENDPOINTS_LESSON_PROJECT.DELETE(id));

  // ----------------------------------------------------------------------
  // LessonProjectCondition
  // ----------------------------------------------------------------------
  const checkProjectEligibility = (userId: number, projectTypeId: number) =>
    apiClient.get(
      `${ENDPOINTS_LESSON_PROJECT_CONDITION.CHECK}?user_id=${userId}&project_type_id=${projectTypeId}`
    );

  const getProjectList = () =>
    apiClient.get<TProject[]>(ENDPOINTS_PROJECT_LIST.GET_PROJECT_LIST);

  const getSchoolStore = () =>
    apiClient.get<TProject[]>(
      ENDPOINTS_STORE.GET_SCHOOL
    );
  const getTilmicodeStore = () =>
    apiClient.get<TProject[]>(
      ENDPOINTS_STORE.GET_TILMICODE
    );

  // -------------------------------------------------------------------------
  // Comments
  // -------------------------------------------------------------------------
  const getAllComments = () =>
    apiClient.get<TComment[]>(ENDPOINTS_COMMENTS.GET_ALL); // GET /comments

  const getCommentById = (id: number) =>
    apiClient.get<TComment>(ENDPOINTS_COMMENTS.GET_BY_ID(id)); // GET /comments/:id

  const createComment = (data: TComment) =>
    apiClient.post<TComment>(ENDPOINTS_COMMENTS.POST, data); // POST /comments

  const updateComment = (id: number, data: TComment) =>
    apiClient.put<TComment>(ENDPOINTS_COMMENTS.PUT(id), data); // PUT /comments/:id

  const deleteComment = (id: number) =>
    apiClient.delete(ENDPOINTS_COMMENTS.DELETE(id)); // DELETE /comments/:id

  const getCommentsByUserAppId = () =>
    apiClient.get<TComment[]>(ENDPOINTS_COMMENTS.GET_BY_USERAPP_ID()); // GET /comments/user/:userapp_id

  const getCommentsByProjectId = (project_id: number) =>
    apiClient.get<TComment[]>(ENDPOINTS_COMMENTS.GET_BY_PROJECT_ID(project_id)); // GET /comments/project/:project_id

  // -------------------------------------------------------------------------
  // NEW - Likes (ajouté)
  // -------------------------------------------------------------------------
  const toggleLike = (projectId: number) =>
    apiClient.post<TToggleLike>(ENDPOINTS_LIKES.TOGGLE(projectId));
  const getLikesByUserId = (userId: number) =>
    apiClient.get<TProjectLike[]>(ENDPOINTS_LIKES.GET_LIKES_BY_USER_ID(userId));

  return {
    getProjects,
    getProjectById,
    getProjectsByUserAppId,
    createProject,
    updateProject,
    deleteProject,

    getAllLessonProjects,
    getLessonProjectById,
    createLessonProject,
    updateLessonProject,
    deleteLessonProject,

    checkProjectEligibility,

    // ---------------------------------------------------------------------
    // Store
    getProjectList,
    getSchoolStore,
    getTilmicodeStore,
    // ---------------------------------------------------------------------
    // Comments
    getAllComments,
    getCommentById,
    createComment,
    updateComment,
    deleteComment,
    getCommentsByUserAppId,
    getCommentsByProjectId,

    toggleLike,
    getLikesByUserId,
  };
};
